import React, { useState, useEffect } from "react";
// ANT DESIGN COMPONENTS
import { Select } from "antd";
// FONT AWESOME LIBRARY AND ICONS
import { faPlus, faPen } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// REDUX
import { useGetCitiesMutation } from "../../../redux/countriesStatesCitiesAPI";
// INTERFACES
import { FormularyRowSelectCityInterface } from "../../../interfaces/FormularyRow";

export default function FormularyRowSelectCity({
	record,
	text,
	value,
	inputIcon,
	formAction,
	itemId,
	textLink,
	onChangeFormValue,
	country,
	countryState,
}: FormularyRowSelectCityInterface) {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */
	const { Option } = Select;

	// ************************************************ */
	// USE STATE VARIABLES **************************** */
	const [listCities, setListCities] = useState<any[]>([]);

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */

	// ************************************************ */
	// CUSTOM HOOKS *********************************** */

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */
	const [triggerGetCities, { data, isLoading, reset: resetGetCities }] = useGetCitiesMutation();

	// ************************************************ */
	// FUNCTIONS ************************************** */

	// ************************************************ */
	// USE EFFECT ************************************* */
	// eslint-disable-next-line arrow-body-style
	useEffect(() => {
		return () => {
			resetGetCities();
		};
	}, []);

	useEffect(() => {
		if (
			countryState &&
			countryState !== "" &&
			country &&
			country !== "" &&
			(record.id === "" || record.id === itemId)
		) {
			triggerGetCities({ country, state: countryState });
		}
	}, [countryState]);

	useEffect(() => {
		if (data && data.data && data.data.length > 0) {
			setListCities(data.data);
		}
	}, [data]);

	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<>
			{record.id === "" ? (
				<Select
					className='generalStyles__width100'
					disabled={listCities.length === 0 || formAction === "edit"}
					showSearch
					optionFilterProp='children'
					filterOption={(input: any, option: any) => option.children.toLowerCase().includes(input.toLowerCase())}
					onChange={(e: any) => {
						onChangeFormValue(e, "city");
					}}
					size='small'
					value={formAction === "create" ? value : null}
					loading={isLoading}
					suffixIcon={inputIcon ? <FontAwesomeIcon icon={faPlus} className='generalStyles__info' /> : null}
				>
					{listCities.map((c) => (
						<Option key={c} value={c}>
							{c}
						</Option>
					))}
				</Select>
			) : (
				<>
					{formAction === "edit" && record.id === itemId ? (
						<Select
							className='generalStyles__width100'
							disabled={listCities.length === 0}
							showSearch
							optionFilterProp='children'
							filterOption={(input: any, option: any) => option.children.toLowerCase().includes(input.toLowerCase())}
							onChange={(e: any) => {
								onChangeFormValue(e, "city");
							}}
							size='small'
							value={value}
							loading={isLoading}
							suffixIcon={inputIcon ? <FontAwesomeIcon icon={faPen} className='generalStyles__info' /> : null}
						>
							{listCities.map((c) => (
								<Option key={c} value={c}>
									{c}
								</Option>
							))}
						</Select>
					) : (
						<div className={textLink ? "generalStyles__info" : ""}>{text}</div>
					)}
				</>
			)}
		</>
	);
}
